import React from 'react'
import { Button } from 'react-bootstrap'
import PublishContent2Point0 from '../../Services/Mutations/PublishContent2Point0'
import { Auth } from 'aws-amplify'


function RenderContentData(props) {
	const approveContent = async () => {
		const { selectedContentLanguages, selectedContentId } = props
		console.log(selectedContentId, 'selectedContentId')

		const input = {
			PK: 'cont#' + props.contentID,
			SK: 'm#draft',
			approveContentInLanguages: [props.contentLanguage],
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 62,
			},
			contentPublishedBy: props.loggedInUserId,
		}
		console.log(input, 'input')
		const publishContentResponse = await PublishContent2Point0(input)
		console.log(publishContentResponse, 'publishContentResponse')
		if (publishContentResponse.statusCode == 'A270') {
			props.displayToast('success', 'Content Approved Successfully')
			if (props.duplicateContent) {
				setTimeout(() => {
					window.location.href = window.location.origin;
				}, 2000)
			} else {
				setTimeout(() => {
					window.location.reload()
				}, 2000)
			}
		} else {
			props.displayToast('error', 'Failed To Approve Content')
		}
	}
	console.log(props.data, 'data in rendercontentdataaaaaaaaaaaaaaaaaa')
	console.log(props.data[`bigTextTitle_${props.contentLanguage}`], 'props.data[`bigTextTitle_${props.contentLanguage}`]')
	const SendPnEnabled = props.data.sendPNWithImage || props.data[`bigTextTitle_${props.contentLanguage}`]
	return (
		<>
			<Button className={'approveContent'} onClick={() => approveContent()} variant='primary'>
				{'Approve Content'}
			</Button>
			<table class="table m-2">
				<tbody>
					<tr>
						<td className='font-weight-bold w-50'>Content Language</td>
						<td>
							{props.contentLanguage}
						</td>
					</tr>

					<tr>
						<td className='font-weight-bold w-50'>
							Send Pn
						</td>
						<td>
							{
								SendPnEnabled ? 'true' : 'false'
							}
						</td>
					</tr>
					{
						SendPnEnabled ?

							<>
								<tr>
									<td className='font-weight-bold w-50'>
										PN Title
									</td>
									<td>
										{props.data[`pnTitle_${props.contentLanguage}`] ? props.data[`pnTitle_${props.contentLanguage}`] : "-"}
									</td>
								</tr>
								{
									props.data.sendPNWithImage ?
										<tr>
											<td className='font-weight-bold w-50'>
												PN Description
											</td>
											<td>
												{props.data[`pnDescription_${props.contentLanguage}`] ? props.data[`pnDescription_${props.contentLanguage}`] : "-"}
											</td>
										</tr>
										:
										<tr>
											<td className='font-weight-bold w-50'>
												Big Text
											</td>
											<td>
												{
													props.data[`bigTextTitle_${props.contentLanguage}`] ? props.data[`bigTextTitle_${props.contentLanguage}`] : '-'
												}
											</td>
										</tr>

								}

								<tr>
									<td className='font-weight-bold w-50'>
										PN Priority
									</td>
									<td>
										{props.data.pnPriority}
									</td>
								</tr>
							</>
							: null
					}

					<tr>
						<td className='font-weight-bold w-50'>
							Sync To Yousaytv
						</td>
						<td>
							{`${props.data.syncToYousaytv ? true : false}`}
						</td>
					</tr>
					<tr>
						<td className='font-weight-bold w-50'>
							Target Area/Areas
						</td>
						<td>
							{props.data.targetAreaV2.join(',')}
						</td>
					</tr>
					<tr>
						<td className='font-weight-bold w-50'>
							Content Category
						</td>
						<td>
							<span>
								{props.data.contentCategory1}
							</span>
							<span>
								{props.data.contentCategory2}
							</span>
							<span>
								{props.data.contentCategory3}
							</span>
						</td>
					</tr>


					<tr>
						<td className='font-weight-bold w-50'>Content Title</td>
						<td>
							{props.title}
						</td>
					</tr>
					<tr>
						<td className='font-weight-bold w-50'>Content Description</td>
						<td>
							{props.cardDescription}
						</td>
					</tr>
					<tr>
						<td className='font-weight-bold w-50'>
							Main Category
						</td>
						<td>
							{props.data.contentMainCategory}
						</td>
					</tr >
					<tr>
						<td className='font-weight-bold w-50'>
							Content Type
						</td>
						<td>
							{props.data.storyType ? props.data.storyType : props.data.contentType}
						</td>
					</tr>
					<tr>
						<td className='font-weight-bold w-50'>
							stickyPost
						</td>
						<td>
							{`${props.data.stickyPost ? true : false}`}
						</td>
					</tr>
				</tbody>
			</table>
		</>

	)
}

export default RenderContentData
